export default "__VITE_ASSET__BfD2rRsD__"